import { CheckedNodeStatus } from "@mantine/core"
import { TreeNode } from "../../@client/Theasoft_ApiServer__Utils_TreeBase"

function traverse<T>(
  node: TreeNode<T>,
  stateMap: Map<string, CheckedNodeStatus>,
  result: { label: string; value: string }[],
  depth = 0
) {
  const state = stateMap.get(node.value)

  if (!state) {
    return
  }

  if (state.checked) {
    result.push({ label: node.label, value: node.value })
    return
  }

  if (state.indeterminate) {
    for (const child of node.children) {
      traverse(child, stateMap, result, depth + 1)
    }
  }
}

// We might need to make this async if performance isnt good enough. Depends on treesize and device performance
export function getSelectedNodes<T>(
  treeNodes: TreeNode<T>[],
  nodeStates: CheckedNodeStatus[]
): { label: string; value: string }[] {
  const result: { label: string; value: string }[] = []

  const stateMap = new Map<string, CheckedNodeStatus>()
  for (const state of nodeStates) {
    stateMap.set(state.value, state)
  }

  // Start traversal for each root node
  for (const node of treeNodes) {
    traverse(node, stateMap, result)
  }

  return result
}
